<template>
  <div>
    <div class="header">
      <h1>Devfinder</h1>
      <p>Find relevant developers from Github</p>
    </div>
    <!-- Using slots -->
    <b-container fluid="sm">
      <b-row class="justify-content-md-center">
        <b-col lg="6">
          <label>Tech/Lang</label>
          <b-form @submit="onSubmit" v-if="show">
            <b-form-group class="mb-2" id="input-group-1">
              <b-form-input
                size="lg"
                id="input-1"
                v-model="language"
                required
                placeholder="Type a technology or language"
              ></b-form-input>
            </b-form-group>

            <label>Location</label>
            <b-form-group
              class="mb-2"
              id="input-group-2"
              description="Try differents names for your region."
            >
              <b-form-input
                size="lg"
                id="input-2"
                v-model="location"
                required
                placeholder="Type the desired location"
              ></b-form-input>
            </b-form-group>

            <b-row class="mt-4 justify-content-md-center">
              <b-col lg="1">
                <b-overlay
                  :show="busy"
                  rounded
                  opacity="0.5"
                  spinner-small
                  size="lg"
                  variant="primary"
                  spinner-variant="light"
                  class="d-inline-block"
                  @hidden="onHidden"
                >
                  <b-button
                    type="submit"
                    size="lg"
                    ref="button"
                    variant="outline-primary"
                    :disabled="busy"
                    @click="asyncData()"
                    ><b-icon-search></b-icon-search>Find</b-button
                  >
                </b-overlay>
              </b-col>
            </b-row>
          </b-form></b-col
        >
      </b-row>
      <nav  v-if="loaded">
        <ul class="pagination">
          <li class="page-item">
            <a class="page-link" @click="previous"
              ><b-icon-chevron-left></b-icon-chevron-left> Previous</a
            >
          </li>
          <li class="page-item">
            <a class="page-link" @click="next"
              >Next <b-icon-chevron-right></b-icon-chevron-right
            ></a>
          </li>
        </ul><p v-if="loaded">({{ this.count }} Results)</p>
        
      </nav>
      <b-row v-if="loaded && paginating">
        <b-col lg="3" v-for="dev in devs" :key="dev.id">
          <a target="_blank" :href="dev.html_url"
            ><b-card no-body style="margin-top: 40px;">
              <template v-slot:header>
                <h4 class="mb-0">{{ dev.name ? dev.name : dev.login }}</h4>
              </template>
              <b-card-img :src="dev.avatar_url" alt="Image" bottom></b-card-img>
              <b-card-body>
                <!-- <b-card-title>Card Title</b-card-title> -->
                <b-card-sub-title class="mb-2">{{
                  dev.location
                }}</b-card-sub-title>
                <b-card-text>
                  {{ dev.bio }}
                </b-card-text>
              </b-card-body>

              <b-card-body>
                <a href="#" class="card-link">{{ dev.followers }} Followers</a>
                <a href="#" class="card-link">{{ dev.public_repos }} Repos</a>
              </b-card-body>
            </b-card>
          </a></b-col
        ></b-row
      >
    </b-container>
  </div>
</template>

<script>
import {
  BIconSearch,
  BIconChevronLeft,
  BIconChevronRight,
} from "bootstrap-vue";
import axios from "axios";
export default {
  name: "Dashboard",
  props: {
    msg: String,
  },
  data() {
    return {
      busy: false,
      devs: [],
      location: "",
      language: "",
      loaded: false,
      show: true,
      page: 1,
      count: 0,
      paginating: true
    };
  },
  components: {
    BIconSearch,
    BIconChevronLeft,
    BIconChevronRight,
  },
  computed: {
    rows() {
      return this.devs.length;
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.asyncData();
    },
    async asyncData() {
      this.busy = true;
      await axios
        .get(
          `https://api.github.com/search/users?q=location:${this.location}+language:${this.language}&sort=followers&order=desc&page=${this.page}&per_page=8`,
          {
            headers: {
              Authorization: process.env.VUE_APP_TOKEN,
            },
          }
        )
        .then((r) => {
          console.log(r);
          this.count = r.data.total_count;
          this.pages = this.count / 8;
          this.devs = r.data.items;
          let count = 0;
          this.devs.map(async (d) => {
            await axios
              .get(d.url, {
                headers: {
                  Authorization: process.env.VUE_APP_TOKEN,
                },
              })
              .then((rs) => {
                count++;
                d.name = rs.data.name;
                d.followers = rs.data.followers;
                d.location = rs.data.location;
                d.bio = rs.data.bio;
                d.public_repos = rs.data.public_repos;
                return;
              });
            if (count === this.devs.length) {
              this.busy = false;
              this.loaded = true;
              this.paginating = true;
            }
          });
        });
    },
    onHidden() {
      // Return focus to the button once hidden
      this.$refs.button.focus();
    },
    next() {
      if (this.page < this.pages) {
        this.paginating = false;
        this.page++;
        this.asyncData();
      }
    },
    previous() {
      if (this.page >= 1) {
        this.paginating = false;
        this.page--;
        this.asyncData();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  text-align: center;
}
.header h1 {
  font-size: 48px;
  color: white;
}
.header p {
  font-size: 28px;
  color: white;
}
label, p {
  color: white;
}
a {
  color: inherit;
}
.card-text{
color: #333;
}
</style>
